import { CircleCheckBigIcon, TrendingUpIcon, UsersIcon } from "lucide-react";
import { CheckList } from "./BulletedList";
import { WelcomeH3 } from "./SectionShell";

export function WelcomeBenefits() {
  return (
    <div className="mt-6">
      <WelcomeH3>
        Veja os benefícios do Gov.PI Proativo
      </WelcomeH3>

      <div className="mt-2 grid grid-cols-1 gap-3 sm:grid-cols-2">
        <div className="rounded-[6px] border border-slate-300 bg-white p-4">
          <div className="flex items-center gap-2 text-sm font-semibold text-slate-900">
            <span className="grid h-6 w-6 place-items-center rounded-full bg-[#EEF6FF] text-[#022A59]">
              <UsersIcon className="h-4 w-4" />
            </span>
            <WelcomeH3>Para você</WelcomeH3>
          </div>
          <CheckList
            items={[
              "Recebe avisos automaticamente",
              "Evita perder prazos importantes",
              "Economiza tempo e reduz burocracia",
              "Aumenta sua transparência",
              "Tem um atendimento digital melhor",
            ]}
            icon={<CircleCheckBigIcon className="h-3 w-3 text-[#022A59]" />}
          />
        </div>

        <div className="rounded-[6px] border border-slate-300 bg-white p-4">
          <div className="flex items-center gap-2 text-sm font-semibold text-slate-900">
            <span className="grid h-6 w-6 place-items-center rounded-full bg-[#EBF5ED] text-[#175330]">
              <TrendingUpIcon className="h-4 w-4" />
            </span>
            <WelcomeH3>Para o governo</WelcomeH3>
          </div>
          <CheckList
            items={[
              "Diminui erros e retrabalhos",
              "Aumenta o uso de serviços digitais",
              "Melhora a comunicação com o cidadão",
              "Garante mais transparência",
              "Antecipar demandas do cidadão",
            ]}
            icon={<CircleCheckBigIcon className="h-3 w-3 text-[#175330]" />}
          />
        </div>
      </div>
    </div>
  );
}
